const isLocalhost = (hostname: string) => hostname === 'localhost' || hostname === '127.0.0.1';

/**
 * Decide which PDF→SVG service URL to call.
 *
 * Priority:
 * 1) If REACT_APP_PDF2SVG_API_URL is set -> use it as-is.
 * 2) If running on localhost -> use VPS defaults (overrideable by env).
 * 3) Otherwise (HTTP or HTTPS) -> same-origin reverse-proxy path (Nginx /pdf2svg/ -> :5001).
 *    Port 5001 does not need to be reachable by clients; only the site port (80/443).
 *
 * Env knobs:
 * - REACT_APP_PDF2SVG_API_URL: full URL, e.g. http://76.13.0.215:5001/convert
 * - REACT_APP_PDF2SVG_VPS_HOST: e.g. 76.13.0.215
 * - REACT_APP_PDF2SVG_PORT: e.g. 5001
 * - REACT_APP_PDF2SVG_PATH: e.g. /convert
 * - REACT_APP_PDF2SVG_HTTPS_PATH: proxy path, e.g. /pdf2svg/convert
 */
export const getPdf2SvgApiUrl = (): string => {
  const explicit = (process.env.REACT_APP_PDF2SVG_API_URL || '').trim();
  if (explicit) return explicit;

  const hostname = window.location.hostname;
  const port = (process.env.REACT_APP_PDF2SVG_PORT || '5001').trim() || '5001';
  const path = (process.env.REACT_APP_PDF2SVG_PATH || '/convert').trim() || '/convert';

  if (isLocalhost(hostname)) {
    const vpsHost = (process.env.REACT_APP_PDF2SVG_VPS_HOST || '76.13.0.215').trim() || '76.13.0.215';
    return `http://${vpsHost}:${port}${path}`;
  }

  // Same-origin reverse-proxy path for both HTTP and HTTPS pages: avoids Mixed Content on HTTPS
  // and means only the site port has to be open (a direct :5001 call fails where only 80 is allowed).
  const proxyPath = (process.env.REACT_APP_PDF2SVG_HTTPS_PATH || '/pdf2svg/convert').trim() || '/pdf2svg/convert';
  return proxyPath; // relative path -> same origin as the page
};

